import { AbstractControl, ValidatorFn } from '@angular/forms';

export function EmailDomainValidator(domain: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const emails = control.value.includes(',')
      ? control.value.split(',')
      : [control.value];
    const invalidEmails = emails.filter(
      (email: string) => !email.trim().endsWith(`@${domain}`)
    );
    return invalidEmails.length > 0
      ? { invalidDomain: { value: control.value } }
      : null;
  };
}
